// Character theme registry. Adding a new theme = adding a new entry here.
// Each product with `theme_slug` matching a key renders a fully themed PDP.

export const THEMES = {
  rapunzel: {
    slug: "rapunzel",
    name: "Rapunzel",
    tagline: "Tangled in golden magic",
    intro:
      "For the dreamers, the sky-gazers, the ones who still wish on lanterns. A limited-edition jewelry story inspired by the golden flower.",
    palette: {
      bg: "#FEF5D8",           // warm candlelight
      surface: "#FDF2E9",      // soft sunrise
      ink: "#3A2C1A",          // warm ink
      gold: "#D4A04C",         // deep gold
      glow: "#F7D070",         // lantern glow
      accent: "#8B5A7C",       // twilight lavender
      forest: "#4A6B4A",       // forest green
      rose: "#E8B4A8",         // sunset rose
    },
    // Character & lifestyle reference imagery — admin can swap in their own via DB if desired.
    // NOTE: Using carefully-curated aesthetic stock photography (long blonde hair, sky lanterns,
    // golden flowers, magical landscapes) that evokes the Rapunzel story without infringing on
    // Disney trademarks. Store owner can upload licensed artwork via the admin panel.
    hero_image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=1000&q=85",             // long hair portrait
    backdrop_image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1800&q=85",         // golden magic hour sky
    lantern_image: "https://images.pexels.com/photos/2085998/pexels-photo-2085998.jpeg?auto=compress&cs=tinysrgb&w=1600",  // sky lanterns at night
    tower_image: "https://images.unsplash.com/photo-1519608487953-e999c86e7455?w=1400&q=85",            // tower silhouette
    flower_image: "https://images.unsplash.com/photo-1597848212624-a19eb35e2651?w=1200&q=85",           // sunflower
    gallery: [
      { src: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=900&q=85",              caption: "Long hair, longer stories." },
      { src: "https://images.pexels.com/photos/2085998/pexels-photo-2085998.jpeg?auto=compress&cs=tinysrgb&w=900", caption: "The night the lanterns rose." },
      { src: "https://images.unsplash.com/photo-1519608487953-e999c86e7455?w=900&q=85",              caption: "A tower all her own." },
      { src: "https://images.unsplash.com/photo-1597848212624-a19eb35e2651?w=900&q=85",              caption: "The golden flower." },
    ],
    story: {
      eyebrow: "The story behind the piece",
      title: "Once upon a time, a single flower held all the magic of the sun.",
      body:
        "The Sunflower Lantern pendant was born from one of our favourite fairytales — of a girl locked in a tower, of a sky lit by a thousand wishes, of hair that shone like molten gold. Every detail of this piece echoes that story: the lantern's gentle curve, the citrine set like a drop of sunlight, the chain that warms against the skin. Wear it on the nights when you need a little magic of your own.",
      quote: "“All the lights will turn you gold.”",
    },
    value_props: [
      { icon: "Sparkles", title: "Sun-lit citrine", body: "A hand-picked natural citrine at the centre — every stone warmer than the last." },
      { icon: "Crown",    title: "18k gold plated", body: "Tarnish-resistant plating on recycled brass. Safe for sensitive skin." },
      { icon: "Leaf",     title: "Ethically sourced", body: "Conflict-free stones, traceable metals. Always." },
      { icon: "Gift",     title: "Fairytale packaging", body: "Arrives in a storybook-style keepsake box with a handwritten note." },
    ],
    cta_background: "https://images.pexels.com/photos/2085998/pexels-photo-2085998.jpeg?auto=compress&cs=tinysrgb&w=1800",
  },
};

export const getTheme = (slug) => THEMES[slug] || null;
